import React from 'react';
import { Box, TextField, Typography, InputAdornment } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { EmailSVG } from '../../svg/EmailSVG';
import { palette } from '../../../styles/theme';

const EmailModalContent = ({ emailField }) => {
    const { t } = useTranslation();
    const { emailFieldValue, setEmailFieldValue } = emailField;
    const handleChange = (e) => {
        let value = e.target.value;
        // Replace any invalid characters with an empty string
        value = value.replace(/[^+a-zA-Z0-9._@-\s]/g, '');
        value = value.replace(' ', '');

        setEmailFieldValue(value);
    };

    return (
        <Box display='flex' flexDirection='column' gap='0.62rem' width='100%' height={'min-content'}>
            <Typography
                variant='body1'
                sx={{
                    color: palette.primary.main,
                    fontSize: '1.08rem',
                    fontWeight: 400
                }}
            >
                {t('email.inputs.modify')}
            </Typography>
            <TextField
                id="outlined-read-only-input"
                value={emailFieldValue}
                variant="outlined"
                inputMode='email'
                placeholder={t('email.inputs.placeholder')}
                onChange={handleChange}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start" sx={{ marginRight: '0.62rem' }}>
                            <EmailSVG customStroke={palette.primary[600]} />
                        </InputAdornment>
                    ),
                    sx: {
                        height: '4rem',
                        borderRadius: '0.62rem',
                        backgroundColor: palette.white,
                        '& fieldset': {
                            borderWidth: '0.08rem',
                            borderColor: palette.disabled[200],
                        },
                        '&:hover fieldset': {
                            borderColor: palette.disabled[300],
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: palette.primary[500],
                        },
                    }
                }}
                sx={{
                    width: '100%',
                }}
            />
        </Box>
    );
};

export default EmailModalContent;
